import { render } from "./PhoneField.vue?vue&type=template&id=bccda400&scoped=true"
import script from "./PhoneField.vue?vue&type=script&lang=js"
export * from "./PhoneField.vue?vue&type=script&lang=js"

import "./PhoneField.vue?vue&type=style&index=0&id=bccda400&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bccda400"]])

export default __exports__